import React from 'react'
import {ParagraphText, Checkbox} from '@thryvlabs/maverick'
//import {usePaymentCheckboxes} from './keap-partner/payment-information-components/contexts/payment-checkboxes-context'
import {useSelector} from 'react-redux'

export const AgreedTermNote = ({
  checkBoxesValues,
  setCheckBoxesValues,
  isAgreeCheckboxDisabled,
  isTaxCalculated,
}) => {
  // const {checkBoxesValues, setCheckBoxesValues, isAgreeCheckboxDisabled} =
  //   usePaymentCheckboxes()

  const {isMobileViewEnable} = useSelector(state => state.screenView)
  const {currentPaymentStep} = useSelector(state => state.paymentScreenView)
  return (
    <>
      <ParagraphText
        variant="sm"
        style={{
          marginTop: '10px',
          marginBottom: '10px',
          fontSize: '14px',
          fontFamily:
            'Open Sans, Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif',
        }}
      >
        *This initial Subscription Period is 6 months
      </ParagraphText>
      <Checkbox
        hasLabel
        name="terms"
        className={`${isMobileViewEnable ? (currentPaymentStep <= 3 ? 'field-disable' : 'field-active') : isAgreeCheckboxDisabled ? 'field-disable' : 'field-active'}`}
        checked={checkBoxesValues.agreedTerms}
        disabled={
          isMobileViewEnable ? currentPaymentStep <= 3 : isAgreeCheckboxDisabled
        }
        onChange={e => {
          setCheckBoxesValues({
            ...checkBoxesValues,
            agreedTerms: e.currentTarget.checked,
          })
        }}
        label={
          <label
            style={{
              fontFamily:
                'Open Sans, Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif',
            }}
          >
            By checking this box, you agree to our{' '}
            <a
              target="_blank"
              href="https://corporate.thryv.com/terms/"
              rel="noreferrer"
            >
              Terms & Conditions
            </a>
          </label>
        }
      />
      <ParagraphText
        variant="sm"
        style={{
          fontFamily:
            'Open Sans, Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif',
        }}
      >
        By processing your payment, you agree that your personal information
        will be shared with Thryv’s payment processor—Adyen, N.V. and will be
        subject to Adyen’s{' '}
        <a
          target="_blank"
          href="https://www.adyen.com/policies-and-disclaimer/privacy-policy"
          rel="noreferrer"
        >
          privacy statement
        </a>
        .
      </ParagraphText>
    </>
  )
}
